import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { FaAngleLeft } from "react-icons/fa";
import { getFeatureDetails } from "../../../../redux/actions/campaignActions";
import Sidebar from "../../../../components/sidebar/Sidebar";
import Navbar from "../../../../components/navbar/Navbar";
import Loader from "../../../../components/Loader/Loader";
import "../../../new/new.scss";

const Viewfeature = () => {
  let token = localStorage.getItem("accessToken");
  const id = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const featureView = useSelector((state) => state.featureView);

  const { feature } = featureView;

  useEffect(() => {
    if (featureView) {
      if (featureView?.loading !== undefined) {
        setLoading(featureView?.loading);
      }
    }
  }, [featureView]);

  useEffect(() => {
    dispatch(getFeatureDetails(token, id, navigate));
  }, [dispatch]);

  return (
    <div className="new">
      <Loader isLoading={loading} />
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <div className="top">
          <span className="backarrow">
            <FaAngleLeft onClick={() => navigate(-1)} />
          </span>
          <h1 className="view-page-tittle">View Feature</h1>
        </div>
        <div className="bottom">
          <div className="left">
            <div className="profile-pic-div">
              <img
                src={feature?.data?.feature_image}
                alt=""
                className="setting-profile"
              />
            </div>
          </div>
          <div className="right">
            <form>
              <div className="formInput">
                <label>Feature Name</label>
                <input
                  type="text"
                  name="feature_name"
                  disabled={true}
                  value={feature?.data?.feature_name}
                  placeholder="Enter First Name"
                />
              </div>
              <div className="formInput">
                <label>Title</label>
                <input
                  type="text"
                  name="feature_title"
                  disabled={true}
                  value={feature?.data?.feature_title}
                  placeholder="Enter Last Name"
                />
              </div>

              <div className="formInput">
                <label> Description</label>

                <textarea
                  type="text"
                  disabled={true}
                  className="description-textarea"
                  value={feature?.data?.feature_description}
                  name="feature_description"
                  cols="47"
                  rows="5"
                  placeholder="Enter Bio"
                ></textarea>
              </div>

              <div className="formInput"></div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Viewfeature;
